import { apiV1 } from '@listen360/js_api_client'

export const namespaced = true

import {
  SEND_DELETE_ITEMS_SUCCESS,
  SEND_DELETE_ITEMS_ERROR,
  SEND_DELETE_ITEMS_PENDING,
  SET_DELETE_PARAMS
} from '@/store/constants'

export const state = {
  isLoading: false,
  errorLoading: false,
  deleteItems: [],
  jobId: '' // returned from post request, use this to check status of bg job
}

export const actions = {
  sendDeleteItems({ commit }, payload) {
    commit(SEND_DELETE_ITEMS_PENDING)

    return apiV1.deleteActionItems
      .create(payload)
      .then(data => {
        commit(SEND_DELETE_ITEMS_SUCCESS, data)
      })
      .catch(() => commit(SEND_DELETE_ITEMS_ERROR))
  }
}

export const getters = {
  jobId: state => state.jobId
}

export const mutations = {
  [SET_DELETE_PARAMS]: (state, expandInput) => {
    state.expandInput = expandInput
  },
  [SEND_DELETE_ITEMS_ERROR]: state => {
    state.isLoading = false
    state.errorLoading = true
  },
  [SEND_DELETE_ITEMS_PENDING]: state => {
    state.isLoading = true
    state.errorLoading = false
  },
  [SEND_DELETE_ITEMS_SUCCESS]: (state, data) => {
    state.isLoading = false
    state.jobId = data
  }
}
